<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelCidade"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    :label="$t('Nome')"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
    :loading="isLoading"
  >
    <template slot="noResult" slot-scope="props">
      <span>{{ $t('Nenhum elemento encontrado.') }}</span>
    </template>
    <template slot="noOptions" slot-scope="props">
      <span>{{ $t('Nenhum dado foi retornado.') }}</span>
    </template>
    <template slot="placeholder" slot-scope="props">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: ['nameField', 'estadoSelected', 'isRequired', 'isDisabled', 'emptyLabel', 'includeAll', 'isObject'],

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'cidade', null);
        return;
      }

      this.$emit('selectChange', 'cidade', this.isObject == true ? e : e.id);
    },
    setValue(value) {
      let selectedActual = this.options.find((option) => option.id === value);
      if (value) {
        this.selected = selectedActual;
      } else {
        this.selected = this.options.find((option) => option.id === null);
        selectedActual = this.options.find((option) => option.id === null);
      }
      this.onChange(selectedActual);
      this.$emit('input', selectedActual);
    },
    setOptions(estadoId) {
      if (!estadoId) {
        return;
      }
      this.isLoading = true;
      this.$atenaList
        .getCidades({
          columns: 'id, nome',
          filter: `estado_id=${estadoId}`,
          order: 'nome',
          limit: 900
        })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(res.data);
          this.setValue(this.nameField);
          // this.onChange();
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    },
    labelCidade({ nome }) {
      return `${nome}`;
    }
  },

  watch: {
    estadoSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setOptions(newVal);
      }
    }
  },

  created() {
    if (this.estadoSelected) this.setOptions(this.estadoSelected);
  }
};
</script>

<style lang="scss" scoped></style>
